<template>
    <div class="shadow-off pt-2 pb-0 pl-0 pr-0">
        <FileUploadsOwn :files="setupList.file" :filevalues="uploaddetails" :editable="true" :storepath="'/v2/bot/analysis/storefile/' + analysisDetails.bpid" :fileproerr="fileprocesserrors" :fileprostage="fileprocessstage" :fileuppercent="fileuploadpercent"
        :filesdataPros="filesdata" :fileconfig="fileConfigInfo" @startloading="$emit('startloading')" @stoploading="$emit('stoploading')" @storedData="$emit('storedData')" :fileuploadeCount="analysisDetails.filecount" :botId="analysisDetails.bpid"
        />
        <div class="mt-4">
            <v-btn data-testid="transaction-matching-config-new__step1-continue-button" color="primary" @click="$emit('continue')" class=" mr-1"><span>Continue</span></v-btn>
        </div>
    </div>
</template>

<script>
    import FileUploadsOwn from '../../TransMatchingFileuploades.vue'
    export default {
        name: 'StepFileUploads',
        components: {
            FileUploadsOwn
        },
        props: {
            setupList: Object,
            uploaddetails: Object,
            analysisDetails: Object,
            fileprocesserrors: Object,
            fileprocessstage: Object,
            fileuploadpercent: Object,
            filesdata: Object,
            fileConfigInfo: Object
        }
    }
</script>